// @ts-nocheck
(function () {
  "use strict";

  var TOGGLE_SELECTOR = "[data-login-password-toggle], [data-password-toggle]";

  function initMask(wrap) {
    var input = wrap.querySelector("[data-password-mask-input]");
    var overlay = wrap.querySelector("[data-password-mask-overlay]");
    if (!input || !overlay) return;

    function render() {
      if (input.type !== "password") {
        overlay.setAttribute("data-mask-hidden", "true");
        return;
      }
      overlay.removeAttribute("data-mask-hidden");

      var desiredCount = input.value.length;
      var currentCount = overlay.children.length;

      if (desiredCount > currentCount) {
        var frag = document.createDocumentFragment();
        for (var i = currentCount; i < desiredCount; i++) {
          var star = document.createElement("span");
          star.className = "password-mask-dot";
          star.textContent = "*";
          frag.appendChild(star);
        }
        overlay.appendChild(frag);
      } else if (desiredCount < currentCount) {
        for (var j = currentCount - 1; j >= desiredCount; j--) {
          overlay.removeChild(overlay.lastChild);
        }
      }
    }

    input.addEventListener("input", render);

    var toggleBtn = wrap.querySelector(TOGGLE_SELECTOR);
    if (toggleBtn) {
      toggleBtn.addEventListener("click", function () {
        // Only handle the account variant; login.js handles the login one
        if (toggleBtn.hasAttribute("data-password-toggle")) {
          var show = input.type === "password";
          input.type = show ? "text" : "password";
          toggleBtn.setAttribute("aria-pressed", String(show));
          toggleBtn.setAttribute(
            "aria-label",
            show ? "Hide password" : "Show password",
          );

          var icon = toggleBtn.querySelector("[data-eye-icon]");
          var src = toggleBtn.getAttribute(
            show ? "data-eye-open-src" : "data-eye-closed-src",
          );
          if (icon && src) icon.src = src;
        }
        setTimeout(render, 0);
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll("[data-password-mask-wrap]").forEach(initMask);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
